import { HTTPRequestMethods } from "../../Shared/httpRequestMethods";
import { parseJsonResponse } from "../../Shared/parseJsonResponse";

export const getBiopharmaGroupsStats = ({ onResponse, onError }) => {
  fetch(
    `/api/job_prospects_stats/biopharma_groups`,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const getExternalJobBoardsStats = ({ onResponse, onError }) => {
  fetch(
    `/api/job_prospects_stats/external_job_boards`,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const getJobDescriptionsStats = ({ onResponse, onError }) => {
  fetch(
    `/api/job_prospects_stats/job_descriptions`,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const getMatchScoresStats = ({ onResponse, onError }) => {
  fetch(
    `/api/job_prospects_stats/match_scores`,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const getJobProspectsStats = ({ onResponse, onError }) => {
  fetch(
    `/api/job_prospects_stats/job_prospects`,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const scheduleBiopharmaWebpageCaching = ({ onResponse, onError, body }) => {
  fetch(
    `/api/job_prospects_stats/schedule_biopharma_webpage_caching`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const scheduleFindExternalJobBoards = ({ onResponse, onError, body }) => {
  fetch(
    `/api/job_prospects_stats/schedule_find_external_job_boards`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const scheduleExternalJobBoardWebpageCaching = ({ onResponse, onError, body }) => {
  fetch(
    `/api/job_prospects_stats/schedule_external_job_board_webpage_caching`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const scheduleFailedExternalJobBoardWebpageCaching = ({ onResponse, onError, body }) => {
  fetch(
    `/api/job_prospects_stats/schedule_failed_external_job_board_webpage_caching`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const scheduleExternalJobBoardJobSync = ({ onResponse, onError, body }) => {
  fetch(
    `/api/job_prospects_stats/schedule_external_job_board_job_sync`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const scheduleLineImportanceAnalysis = ({ onResponse, onError, body }) => {
  fetch(
    `/api/job_prospects_stats/schedule_line_importance_analysis`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const scheduleMatchScoreCalculation = ({ onResponse, onError, body }) => {
  fetch(
    `/api/job_prospects_stats/schedule_match_score_calculation`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const scheduleJobProspectCreation = ({ onResponse, onError, body }) => {
  fetch(
    `/api/job_prospects_stats/schedule_job_prospect_creation`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const getUserPipelineDebug = ({ userId, onResponse, onError }) => {
  const url = userId
    ? `/api/job_prospects_stats/user_pipeline_debug?user_id=${userId}`
    : `/api/job_prospects_stats/user_pipeline_debug`;

  fetch(url, {
    method: HTTPRequestMethods.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  })
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const generateMatchScoresForUser = ({ userId, onResponse, onError }) => {
  fetch(
    `/api/users/${userId}/generate_match_scores`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const scheduleCloseStaleJobDescriptions = ({ onResponse, onError, body }) => {
  fetch(
    `/api/job_prospects_stats/schedule_close_stale_job_descriptions`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};
